import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { refundFormSchema } from './refund-form.schema';

export const useRefundDrawerForm = context => {
  const form = useForm({
    resolver: yupResolver(refundFormSchema, context),
    defaultValues: refundFormSchema.cast(),
  });

  return { form };
};
